module.exports = __webpack_public_path__ + "img/logo1.de969291.png";